"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Home = void 0;
const react_native_1 = require("react-native");
const react_1 = __importStar(require("react"));
const Home_style_1 = require("./Home.style");
const atome_1 = require("../../atome");
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
// @ts-ignore
function Home({ navigation }) {
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    (0, react_1.useEffect)(() => {
        return () => { };
    }, []);
    if (auth.isAuthenticated) {
        navigation.navigate('Dashboard');
    }
    else {
        navigation.navigate('Login');
    }
    return (react_1.default.createElement(react_native_1.View, { style: Home_style_1.styles.container },
        react_1.default.createElement(react_native_1.View, { style: Home_style_1.styles.start },
            react_1.default.createElement(atome_1.Text, { style: [Home_style_1.styles.loading] }, "Loading..."),
            react_1.default.createElement(react_native_1.Pressable, { onPress: () => navigation.navigate('Login') },
                react_1.default.createElement(atome_1.Text, null, "Test")))));
}
exports.Home = Home;
